<script setup lang="ts">
// SPEC §8.1 — yellow banner shown whenever isTest === true.
defineProps<{ inactive?: boolean; stopped?: boolean }>();
</script>

<template>
  <div class="space-y-2">
    <div
      role="status"
      class="rounded-md border border-yellow-300 bg-yellow-100 px-4 py-3 text-sm font-medium text-yellow-900"
      data-testid="test-banner"
    >
      {{ $t("buy.banner.test") }}
    </div>
    <div
      v-if="inactive"
      role="status"
      class="rounded-md border border-orange-300 bg-orange-100 px-4 py-2 text-sm font-medium text-orange-900"
      data-testid="inactive-badge"
    >
      {{ $t("buy.banner.inactive") }}
    </div>
    <div
      v-if="stopped"
      role="status"
      class="rounded-md border border-orange-300 bg-orange-100 px-4 py-2 text-sm font-medium text-orange-900"
      data-testid="stopped-badge"
    >
      {{ $t("buy.banner.stopped") }}
    </div>
  </div>
</template>
